<div class="content-wrapper">

    <div class="content-header row">
        <div class="content-header-left col-md-8 col-12 mb-2 breadcrumb-new">
            <h3 class="content-header-title mb-0 d-inline-block">
                Licencias
            </h3>
            <div class="row breadcrumbs-top d-inline-block">
                <div class="breadcrumb-wrapper col-12">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a routerLink="/dashboard">
                                Dashboard
                            </a>
                        </li>
                        <li class="breadcrumb-item">
                            <a routerLink="/licencias">
                                licencias
                            </a>
                        </li>
                        <li class="breadcrumb-item active">
                            Lista de licencias
                        </li>
                    </ol>
                </div>
            </div> 
        </div>
        <div class="content-header-right col-md-4 col-12">
            <div class="btn-group float-md-right">
                <button class="btn btn-info dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    <i class="icon-settings mr-1"></i>
                    Opciones
                </button>
                <div class="dropdown-menu arrow">
                    <a class="dropdown-item" routerLink="/licencias/agregar" *ngIf="permisos['LICENSES_CREATE']">
                        <i class="fa fa-plus-circle" aria-hidden="true"></i>
                        Nuevo
                    </a>
                </div>
            </div>
        </div>
    </div>


    <div class="content-body">

        <!-- Basic Tables start -->
        <div class="row">

            <div class="col-12">

                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">
                            Lista de Licencias
                        </h4>
                        <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                        <div class="heading-elements">
                            <ul class="list-inline mb-0">
                                <li><a data-action="collapse"><i class="ft-minus"></i></a></li>
                                <li><a data-action="reload"><i class="ft-rotate-cw"></i></a></li>
                                <li><a data-action="expand"><i class="ft-maximize"></i></a></li>
                                <li><a data-action="close"><i class="ft-x"></i></a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="card-content collapse show">

                        <div class="card-body">
                            <p class="card-text">
                                Aqui se muestra todos los registros de licencias que hay actualmente en la plataforma
                            </p>
                            <div class="row">
                                <div class="col-2 offset-1">
                                    <div class="form-group position-relative has-icon-left m-0">
                                        <input type="date" class="form-control"  [(ngModel)]="filtro.fecha_inicio" name="fecha_inicio" >
                                        <div class="form-control-position">
                                            <i class="ft-calendar"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2 offset-1">
                                    <div class="form-group position-relative has-icon-left m-0">
                                        <input type="date" class="form-control"  [(ngModel)]="filtro.fecha_fin" name="fecha_fin" >
                                        <div class="form-control-position">
                                            <i class="ft-calendar"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4 offset-2">
                                    <div class="form-group position-relative has-icon-left m-0">
                                        <input type="search" class="form-control" id="iconLeft4" placeholder="Buscar" [(ngModel)]="filtro.search" name="search" >
                                        <div class="form-control-position">
                                            <i class="ft-search"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Empresa</th>
                                            <th>Plan</th>
                                            <th>Fecha de Inicio</th>
                                            <th>Fecha de Vencimiento</th>
                                            <th>Estado</th>
                                            <th>Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let licencia of licencias | dateFilter: filtro.fecha_inicio: filtro.fecha_fin | gridFilter: filtro.search | paginate: { itemsPerPage: 10, currentPage: page }; let i = index;">
                                            <th scope="row">
                                                {{licencia.consecutivo}}
                                            </th>
                                            <td>
                                                {{licencia.empresa.razon_social}}
                                            </td>
                                            <td>
                                                {{licencia.plan.nombre}}
                                            </td>
                                            <td>
                                                {{licencia.fecha_inicio | date}}
                                            </td>
                                            <td>
                                                {{licencia.fecha_vencimiento | date}}
                                            </td>
                                            <td>
                                                {{licencia.estado}}
                                            </td>
                                            <td>
                                                <div class="btn-group" role="group" >
                                                    <a class="btn btn-light "
                                                        routerLink="/licencias/{{licencia._id}}/detalles" *ngIf="permisos['LICENSES_READ']">
                                                        <i class="fa fa-search-plus" aria-hidden="true"></i>
                                                    </a>
                                                    <a class="btn btn-light "
                                                        routerLink="/licencias/{{licencia._id}}/modificar" *ngIf="permisos['LICENSES_UPDATE']">
                                                        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                                    </a>
                                                    <button type="button" class="btn btn-danger" (click)="remove(licencia._id, i)" *ngIf="permisos['LICENSES_DELETE']">
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <pagination-controls (pageChange)="page = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
                            </div>
                        </div>

                    </div>
                </div>
                
            </div>
        </div>
        <!-- Basic Tables end -->

    </div>


</div>